<template>

<div class="">
 
 <!-- <div  class="loader"></div> -->
   <loader v-if="loading" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>


   <div class="float-right">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" @click="$bvModal.show('modal-lg')"> <b-icon icon="filter"></b-icon> Filter</b-button>

  


</div>


 <b-modal id="modal-lg" size="lg" title="Filter" hide-footer>
   
  <div class="panal2">
    <div>
      
      <div class="panal-header2"> </div>
     <div class="panal-body2" id="Courses">

  <div class="filter">

   <b-form-group label="">
      <b-form-radio-group id="radio-group-2"  name="radio-sub-component">
        <b-form-radio value="All" v-model="FilterCourses" >All Courses</b-form-radio>

        <b-form-radio value="Selected" v-model="FilterCourses">Selected courses</b-form-radio>
      </b-form-radio-group>
    </b-form-group>



  </div>
  <hr/>
  <div>
  <h6> Levels </h6>
<span class="col-md-4">Student level</span>
<b-form-select v-model="LevelNameinsert"  class="col-md-9">

      <b-form-select-option v-for = "Level in LevelName" v-bind:key="Level.serial" :value="Level.serial" >{{ Level.StageName }}</b-form-select-option>
    

</b-form-select>


</div>

<hr/>
  <div>
  <h6>Specialization </h6>
<span class="col-md-2">Student Specialization</span>
 <b-form-select v-model="Specializationinsert" class="mb-3 col-md-8">
      <!-- <b-form-select-option :value="null">Please select an option</b-form-select-option> -->
      <b-form-select-option  v-for = "spac in Specialization" v-bind:key="spac.SpecializationID" :value="spac.SpecializationID">{{spac.SpecializationNameEN}}</b-form-select-option>
      
    </b-form-select>


</div>

<hr/>
  <div>
  <h6>Courses </h6>
  <b-row>
 <b-col class="col-md-2 mt-1">Course Code</b-col>
  <b-form-input v-model="text1" class="col-md-3" placeholder="Enter course code"></b-form-input>
  <b-col class="col-md-2 mt-1">Course Name</b-col>
  <b-form-input v-model="text2" class="col-md-4" placeholder="Enter course Name"></b-form-input>
  </b-row>
   

</div>



      </div>
     </div>

  

  </div>
<div class="text-center col-md-3 float-right">
<b-button class="mt-3  btn-success" block @click="$bvModal.hide('modal-lg'),filteredCourses2() ">Search</b-button></div>
  </b-modal>

   <br/>
   <div class="clearfix"></div>
   

<div class="row">
   <b-col sm="12" md="3" class="border-right">
     <b-alert show variant="dark">
     
    <!-- v-for = "item in Courses" v-bind:key="'select-'+item.serial" -->

      <div class="row" >
        <div class="col-md-6 text-center"><h6>Current CGPA<br/><span class="text-success">{{Courses[0].CGPA}}</span></h6></div>
         <div class="col-md-6 text-center"><h6>Current Credit<br/><span class="text-success">{{Courses[0].SelectedCredits}}</span></h6></div>
      </div>

<hr/>
      <div class="row">
         <div class="col-md-12 text-center"><h6>Resulted CGPA<br/><span class="text-success">{{Courses[0].ResultedCGPA}}</span></h6></div>
        <div class="col-md-12 text-center"><h6>Resulted GPA<br/><span class="text-success">{{Courses[0].SelectedGPA}}</span></h6></div>
        
      </div>
      <hr/>
 <div class="row">
        <div class="col-md-12 text-center"><h6>Selected Credits<span class="text-success ml-2">{{Courses[0].SelectedCredits}}</span></h6></div>
        
      </div>
      <hr/>
      <div class="row">
        <div class="col-md-12 text-center"><h6>Total Credits<span class="text-success ml-2">{{Courses[0].TotalCredits}}</span></h6></div>
        
      </div>
     </b-alert>
     






   </b-col>
  <b-col sm="12" md="9" class="row">

 <!-- :class="{active2:item.id == selected1}" @click="selected1 = item.id" -->
    <b-card-group deck v-for = "item in Courses" v-bind:key="item.serial" class="col-md-6 col-sm-12 mb-3" >
     
<!-- :class="{ active2 : deleteClicked }" ="isHidden = !isHidden"-->
      <b-card  :header="item.CourseCode"  :id="item.serial" variant="primary" class="select" border-variant="primary" sm="12"  :class="item.Selected ? 'active2' : ''" >
     <b-card-text>Course Name.:{{item.CourseNameEN}}<br/>CreditHours: {{item.CreditHours}}  </b-card-text>
        <hr/>
      <div>
              <!-- v-bind:disabled="!item.Selected ?  true: false" -->
             <fieldset v-bind:disabled="!item.Selected ?  true: false" :id="'select-'+item.serial">
        Grade <select class="w-50" v-model="selected22[item.serial]" @change="onChange(item.serial,$event)">
          <!-- <option>Select</option> -->
          <option v-for = "Grade in item.Grades" v-bind:key="Grade.GradeSerial" :value="Grade.GradeSerial" >{{Grade.GradeName}}</option>
           <!-- <option>B</option> -->
          
          </select>
             </fieldset>
          </div>
         
         <div class="text-center"><b-button @click="onClick(item);"  class="subButton" > {{ item.Selected? 'DeSelect' : 'Select' }}</b-button></div>
        <!-- <b-modal id="modal-center" size="lg" centered title="PHG 1101" cancel-only>
    
<b-row>
    <b-col cols="12" md="6" class="border-right">
      <b-button variant="primary">Lecture</b-button>
      
    <div class="responsive w-100">  
  <table class="table  hover bordered  w-100 table-bordered table-striped mb-2">
    <tr>
    
   
       <th> Select</th>
       <th>Section Number</th>
       <th>Available Seats</th>
       <th>Instructor Name</th>
    
     </tr>
     <tr>
       <td><input type="radio"/></td>
        <td>002</td>
         <td>5</td>
          <td>Ahmed Mohamed</td>
     </tr>
     <tr class="table-success">
       <td colspan="4" variant="success"><strong> Day:</strong> Saturday From 9:00am to 10:55 <strong> Number:</strong> A-213</td>
 
     </tr>
    </table>
 
      </div>
     
     </b-col>
    <b-col cols="12" md="6">


<b-button variant="primary">LAB</b-button>

 <div class="responsive w-100">  
  <table class="table  hover bordered  w-100 table-bordered table-striped mb-2">
    <tr>
    
   
       <th> Select</th>
       <th>Section Number</th>
       <th>Available Seats</th>
       <th>Instructor Name</th>
    
     </tr>
     <tr>
       <td><input type="radio"/></td>
        <td>002</td>
         <td>5</td>
          <td>Ahmed Mohamed</td>
     </tr>
     <tr class="table-success">
       <td colspan="4" variant="success"><strong> Day:</strong> Saturday From 9:00am to 10:55 <strong> Number:</strong> A-213</td>
 
     </tr>
    </table>
 
      </div>

    </b-col>
  </b-row>




<template #modal-footer="{ ok, cancel,}">
     
    
        <b-button @click="onClick(); ok();" size="sm" variant="success">
      Add To Cart
    </b-button>
      <b-button size="sm" variant="danger" @click="cancel()">
        Back
      </b-button>
    
    </template>

  </b-modal> -->
        
      
      </b-card>
     <!-- <b-card header="PHG 1101" class="col-md-4 col-sm-12 bg-primary text-white " border-variant="primary" >
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3 </b-card-text>
<hr/>
         <div>
        Grade <select class="w-50">
         
           <option>B</option>
            <option>A+</option>
          
          </select>
          </div>
        
         <div class="text-center"><b-button  class="subButton">Deselect</b-button></div>
        
       
      </b-card>
    <b-card header="PHG 1101" class="col-md-4 col-sm-12" border-variant="primary">
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3</b-card-text>
             <hr/>
             <fieldset disabled>
        <div class="disabled">
        Grade <select class="w-50 " id="disabledSelect">
          <option>A+</option>
           <option>B</option>
          
          </select>
        </div>
             </fieldset>
 

         <div class="text-center"><b-button  class="subButton">Select</b-button></div>
      </b-card>
       <b-card header="PHG 1101" class="col-md-4 col-sm-12" border-variant="primary">
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3</b-card-text>
          <hr/>
             <fieldset disabled>
        <div class="disabled">
        Grade <select class="w-50 " id="disabledSelect">
          <option>A+</option>
           <option>B</option>
          
          </select>
        </div>
             </fieldset>
         <div class="text-center"><b-button  class="subButton">Select</b-button></div>
         
      </b-card>
       <b-card header="PHG 1101" class="col-md-4 col-sm-12 " border-variant="primary">
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3</b-card-text>
          <hr/>
             <fieldset disabled>
        <div class="disabled">
        Grade <select class="w-50 " id="disabledSelect">
          <option>A+</option>
           <option>B</option>
          
          </select>
        </div>
             </fieldset>
         <div class="text-center"><b-button  class="subButton">Select</b-button></div>
      </b-card>
          <b-card header="PHG 1101" class="col-md-4 col-sm-12 bg-primary text-white " border-variant="primary">
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3</b-card-text>
          <hr/>
             <fieldset disabled>
        <div class="disabled">
        Grade <select class="w-50 " id="disabledSelect">
          <option>A+</option>
           <option>B</option>
          
          </select>
        </div>
             </fieldset>
         <div class="text-center"><b-button  class="subButton">Deselect</b-button></div>
      </b-card> -->
    </b-card-group>
 



  </b-col>





</div>






</div>
</template>
<script>
 import studentData from '../../services/student/studentDataServices';

    export default {
        name: 'SelectSubject',
        data() {
          
      return {
        loading: false,
       FilterCourses:'',
        btnDisable:true,
        selected1: undefined,
        selected22:'',
        IsSelected:false,
        Courses:[''],
        SelectCourses:[],
        text1:'',
        text2:'',
       LevelName:'',
       LevelNameinsert:'0',
       Specialization:'',
       Specializationinsert:'0',
        
        deleteClicked: false,
        change: false,
        selected2: null,
        selected: '',
       expanded: true,
      text: "Select",
      CoursesSelect:'',
        
        
      } 
      
    },
    // beforeCreate:  function() {
   
    // },
     created(){
       this.loading = true
            //this.currenUser.StudentID
           studentData.GetCoursesForSelection(this.currenUser.StudentID,0,0,0,'','',this.IsSelected).then(Response =>{
              //this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false
               // eslint-disable-next-line no-console
            this.loading = false
                  // console.log('cources => ', this.Courses )
             
                // this.levels = this.AcademicPlan.map(item=> item.LevelName)
                // this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 


               //this.currenUser.FacultyID_Enrollment
           studentData.GetFacultyLevels(this.currenUser.FacultyID_Enrollment).then(Response =>{
            //   this.isLoading = false ;
               this.LevelName = Response.data
                this.empty =false
              //  console.log()
             
                // this.levels = this.AcademicPlan.map(item=> item.LevelName)
                // this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
                studentData.GetFacultySpecializations(this.currenUser.FacultyID_Enrollment).then(Response =>{
            //   this.isLoading = false ;
               this.Specialization = Response.data
                this.empty =false
              //  console.log()
             
                // this.levels = this.AcademicPlan.map(item=> item.LevelName)
                // this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 


               
       },
   computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
        
   




       },

 
  methods:{
             filteredCourses2(){

this.IsSelected = false;
  this.loading = true;


            // console.log(10, this.FilterCourses);
        //   return this.Courses.filter((item)=>{

          if(this.FilterCourses === "All") { 

         this.IsSelected = false;
          } else 
          {
         this.IsSelected = true;
          }

        //   });
             studentData.GetCoursesForSelection(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert, this.LevelNameinsert,this.text1,this.text2,this.IsSelected).then(Response =>{
              this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false
              //  console.log()
                this.loading = false;
             
                this.levels = this.AcademicPlan.map(item=> item.LevelName)
                this.levels = [...new Set(this.levels)]
                
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
        this.text1='';
        this.text2='';
        this.LevelNameinsert='0';
        this.IsSelected = false;
        this.Specializationinsert='0';
          //  localStorage.removeItem(this.IsSelected=false);

        },
onChange(serial,event) {
this.loading = true;
   studentData.OnChangeGradeSelect(this.currenUser.StudentID,0,0,0,this.text1,this.text2,this.IsSelected,serial,event.target.value).then(Response =>{
            //   this.isLoading = false ;
             
               this.Courses = Response.data
                this.empty =false
                 this.loading = false;
              //  console.log()
             
                // this.levels = this.AcademicPlan.map(item=> item.LevelName)
                // this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
              event.preventDefault()
            },
//             mounted (){
//   this.onChange (this.$route.params.Response.data)
// },



     onClick(item) {
    // this.deleteClicked = true;
     this.loading = true;

    let selectStatus = item.Selected? 1 : 0;
// console.log( item.Selected, selectStatus);
      

        //this.currenUser.StudentID
        
           studentData.SelectDeselectCourse(this.currenUser.StudentID,0,0,0,this.text1,this.text2,this.IsSelected,item.serial,selectStatus).then(Response =>{

 this.Courses = Response.data 
 this.empty =false
       
 this.CoursesSelectItem = this.Courses.filter(function(newItem){
   if(newItem.serial == item.serial){
     return newItem;
   }
 })

this.CoursesSelect = this.CoursesSelectItem[0]['Selected'];
//  this.CoursesSelect = !this.CoursesSelect;

 if (this.CoursesSelect==0) {
       document.getElementById(item.serial).classList.add("active2");
       document.getElementById('select-'+item.serial).disabled = false;  
         this.text = "DeSelect";
        
      }  else if(this.CoursesSelect==1) {
         this.text = "Select";
      }
    
              // if (Response.data.SelectDeselect == 1) {
                         
                       
                          
              //             }else{
              //                 document.getElementById(serial).classList.add("primary");
              //             document.getElementById('select-'+serial).disabled = true;

              //             }
                   
            //   this.isLoading = false ;
             
              //  alert(Response.data)
              //   this.empty =false
              this.loading = false;
              //  console.log()
             
                // this.levels = this.AcademicPlan.map(item=> item.LevelName)
                // this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       },



   // document.getElementById(serial).classList.add("noclass");
    // this.btnDisable =false
      // if(event.target.className == "noclass")
      //   {event.target.className = "active2" } else
      //   {	event.target.className = "noclass"
      //  }  	



   filteredCourses() {
     studentData.GetCoursesForSelection(this.currenUser.StudentID,0,0,0,'','',false).then(Response =>{
            //   this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false
                
		// this.category = this.FilterCourses;
    if(this.FilterCourses === "All") {
				return this.Courses.Selected === false
			} else if(this.FilterCourses === "Registered") {
			return this.Courses.Registered === true
			}
     
              //  console.log()
             
              //   // this.levels = this.AcademicPlan.map(item=> item.LevelName)
              //   // this.levels = [...new Set(this.levels)]
              //   // eslint-disable-next-line no-console
              //     console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 


	
		}



      
    },
        // ok()
        // {
        //  this.change = true;
         
        // },
      
         
      
       

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.active2 {
    color: #fff !important;
    
    background-color: #007bff !important;

  }
.active2 button{
  background-color: #28a745 !important;
    margin-bottom: -50px !important;
    width: 50%;

    text-align: center;
    border: 0px;
}

h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}
.border-right {
    border-right: 1px solid #dee2e6 !important;
}
.iconCart{

width: 60px;
height: 70px;
margin: 0 auto;
position: relative;
padding-top:15px
}
.iconCart .cart{
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border:#50BD77 dotted 1px;
    top: 0px;
    background: #fff;
    right: 20px;
    text-align: center;
    color: #50BD77;
    font-size: 18px;

}
ul{
    padding-left:0px;
}
li.menu{
    border-bottom: 1px #646464 dashed;
    color: #285475;
    font-size: 17px;
    list-style: none;
    padding: 10px 0px;
}

.card-deck .card {
   
    -webkit-box-flex: 1;
    flex: 1 0 25%;
   
    margin-bottom: 20px;
    padding: 0;
   
}
.subButton{
  margin-bottom: -50px;
    width: 50%;
    background: #285476;
    text-align: center;
    border: 0px;
}
th, td{
  font-size: 0.7rem !important;
}

.popover.b-popover {
  width:300px;
}

.line{
   border-bottom: 1px #646464 dashed;
   padding: 5px 0px;

}
.custom-control-inline {

    margin-right: 0.5rem !important;
}

.beforloader{
  width: 100%;
    background: #3333331c;
    text-align: center;
}
.beforloader> .loader{
  text-align: center;
}
.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
